'use client';

import { useRef } from 'react';

import { gsap, useGSAP } from '@/lib/gsap';
import useIsMobile from '@/hooks/useIsMobile';

interface CardListAnimatorProps {
  direction: 'up' | 'down' | 'left' | 'right';
  children: React.ReactNode;
}

const FROM_MAP = {
  up: { y: 50, opacity: 0 },
  down: { y: -50, opacity: 0 },
  left: { x: 100, opacity: 0 },
  right: { x: -100, opacity: 0 },
};

const CardListAnimator = ({ direction, children }: CardListAnimatorProps) => {
  const isMobile = useIsMobile();
  const wrapperRef = useRef(null);

  useGSAP(
    () => {
      if (!wrapperRef.current) return;

      const cards = gsap.utils.toArray('.example-card', wrapperRef.current);
      const from = FROM_MAP[direction];
      const startValue = isMobile ? 'top 90%' : 'top 85%';

      gsap.fromTo(cards, from, {
        x: 0,
        y: 0,
        opacity: 1,
        stagger: 0.08,
        duration: 0.7,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: wrapperRef.current,
          start: startValue,
          once: true,
        },
      });
    },
    {
      dependencies: [isMobile],
      revertOnUpdate: true,
    },
  );

  return <div ref={wrapperRef}>{children}</div>;
};

export default CardListAnimator;
